module.exports = __webpack_public_path__ + "img/4.a6a62e73.jpg";